import(/* webpackMode: "eager", webpackExports: ["BuildConfigurator"] */ "/vercel/path0/apps/storefront/app/build/_components/BuildConfigurator.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@15.5.15_@babel+core@7.29.0_@playwright+test@1.59.1_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@15.5.15_@babel+core@7.29.0_@playwright+test@1.59.1_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/shared-ui/src/components/product/ProductCarousel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProductLightbox"] */ "/vercel/path0/packages/shared-ui/src/components/product/ProductLightbox.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SpecsTable"] */ "/vercel/path0/packages/shared-ui/src/components/product/SpecsTable.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UpsellGroupCard"] */ "/vercel/path0/packages/shared-ui/src/components/product/UpsellGroupCard.tsx");
